import cx from 'classnames'
import { Heading } from 'almanac-ui/Heading/Heading'
import Styles from './Field.module.scss'
import { FieldProps } from './Types'
import { CopyButton } from 'components/Wizards/Field/CopyButton'
import { Text, TextVariant } from 'blaze-ui/Text/Text'

const Field = ({
  error = false,
  name,
  label,
  children,
  description,
  isRequired = false,
  direction = 'column',
  copyToClipboard = false,
  rightContent,
  id,
  fieldGap,
  labelType = 'heading',
  headingLevel = 4,
  'data-testid': dataTestId,
}: FieldProps) => {
  const title = (
    <span>
      {label}
      {isRequired && <span className={Styles.star}>&nbsp;*</span>}
    </span>
  )

  return (
    <div className={Styles.fieldContainer} data-testid={dataTestId}>
      <div className={cx(Styles.field, Styles[direction], Styles[labelType])} style={{ gap: fieldGap }}>
        {(label || description) && (
          <div className={cx(Styles.fieldWrapper, { [Styles.withRightContent]: !!rightContent })}>
            <div className={Styles.labelAndDescription}>
              <div className={Styles.headingWrapper}>
                {labelType === 'text' && (
                  <Text variant="placeholder" color="var(--dark-60)">
                    {title}
                  </Text>
                )}
                {labelType === 'label' && (
                  <Text variant={labelType as TextVariant} color="var(--dark-60)">
                    {title}
                  </Text>
                )}
                {labelType === 'secondary' && (
                  <Text variant={labelType as TextVariant} color="var(--dark-80)">
                    {title}
                  </Text>
                )}
                {labelType === 'heading' && (
                  <Heading level={headingLevel} id={id}>
                    {title}
                  </Heading>
                )}
                {error && <span className={Styles.error}>{error}</span>}
                {copyToClipboard && name && <CopyButton name={name} />}
              </div>
              {description && <div className={Styles.description}>{description}</div>}
            </div>
            {!error && !copyToClipboard && rightContent}
          </div>
        )}
        <div>{children}</div>
      </div>
    </div>
  )
}

export { Field }
